__turbopack_context__.v({
  "infos": "iiIwEW_infos",
  "infosWrapper": "iiIwEW_infosWrapper",
  "logo": "iiIwEW_logo",
  "logoWrapper": "iiIwEW_logoWrapper",
});
